import type { CartItem } from "@server/gql/graphql";

import { getNextDeliveryDate } from "@/utils/cart/getNextDeliveryDate";

import { isMadeToOrderItem } from "./isMadeToOrderItem";

/**
 * A cart line is "made to order" when it is a DeliveryItem with no real next
 * delivery. `getNextDeliveryDate` returns undefined when `nextDelivery.quantity`
 * is 0 (how the backend signals "no real next delivery", paired with a sentinel
 * min-date) and for the `0001-01-01` DateTime.MinValue sentinel — without that
 * guard the sentinel date would make a made-to-order line look "soon back in
 * stock" and be excluded.
 */
export const isMadeToOrderCartItem = (
  item?: Pick<CartItem, "stockStatus"> | null,
) => {
  return isMadeToOrderItem(
    item?.stockStatus?.statusCode,
    getNextDeliveryDate(item?.stockStatus?.nextDelivery),
  );
};
